module.exports = __webpack_public_path__ + "img/thaipost0_logo.5f2e6e26.png";